export enum TaskType {

    PUBLISH = 'PUBLISH',
    REVIEW = 'REVIEW',
    REQUEST_APPROVAL = 'REQUEST_APPROVAL',
    CHANGES_REQUESTED = 'CHANGES_REQUESTED',
    SET_ACTIVE = 'SET_ACTIVE',
}